$(document).on('click','.menu-burger,.menu-drawer-close',function (e){
  e.preventDefault();
  $('body').toggleClass('menu-open');
});
$(document).on('click','.menu-drawer-close',function(e){
  e.preventDefault();
  $('body').removeClass('menu-open');
});
// $(window).on('popstate', function(event){
//   alert()
//   var href = event.target.location.href;
//   var domainURL = event.target.location.hostname;
//   var shopURL = window.location.hostname;
//   if(href.charAt(0) != '#'){
//     if($(window).width() > 991){
//       if(localStorage.getItem("scrollLast") != null){
//         console.log(localStorage.getItem("scrollLast"),'last');
//         locoScroll.scrollTo(parseInt(localStorage.getItem("scrollLast")));
//       }
//     }
//   }
// })

// // Handle forward/back buttons
// window.addEventListener("popstate", (event) => {
//   alert()
//   // If a state has been provided, we have a "simulated" page
//   // and we update the current page.
//   if (event.state) {
//     // Simulate the loading of the previous page
//     displayContent(event.state);
//   }
// });
window.addEventListener('hashchange', () => {
  const hash = window.location.hash.substring(1); // Get the hash value
  console.log('Hash changed:', hash);
});